import React from 'react';
import { observer } from 'mobx-react-lite';

import { wheelStore } from '../../store';
import { ResultCircles } from '../common';

export const MobileResultsHistory = observer(() => {
  const { wheelResultsHistory } = wheelStore;

  return (
    <div className='mob-top-h'>
      <div className='mob-top-h-ins'>
        <div className='mob-top-circle-row'>
          <div className='mob-c-row-block'>
            {wheelResultsHistory.map(({ color, id, anim = false }) => (
              <ResultCircles position={anim ? 'prev' : ''} key={id} color={color} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});
